import { Storage } from '@/enums/storage.enum';
import { tryParseInt } from '@/utils/number';

export const getProfileId = () => tryParseInt(localStorage.getItem(Storage.PROFILE_ID) as string);
